import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../modules/auth/services/auth.service';
import { Router } from '@angular/router';
import { ProfileComponent } from '../../../modules/auth/components/profile/profile.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router, private modalService: NgbModal) {
  }

  ngOnInit() {

  }

  logout() {
    this.authService.logout().then(() => {
      this.router.navigate(['/login']);
    });
  }

  public openProfile() {
    this.modalService.open(ProfileComponent, {backdrop: 'static'});
  }

}
